import { render, staticRenderFns } from "./productosBanner.vue?vue&type=template&id=5f7f93fc&scoped=true&"
import script from "./productosBanner.vue?vue&type=script&lang=js&"
export * from "./productosBanner.vue?vue&type=script&lang=js&"
import style0 from "./productosBanner.vue?vue&type=style&index=0&id=5f7f93fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f93fc",
  null
  
)

export default component.exports